import { createRouter, createWebHistory } from 'vue-router'
import LandingView from '../views/LandingView.vue'
import MenuView from '../views/MenuView.vue'
import CheckoutView from '../views/CheckoutView.vue'
import PaymentView from '../views/PaymentView.vue'
import PaymentCompleteView from '../views/PaymentCompleteView.vue'

/**
 * Route Structure:
 * 
 * /{restaurantSlug}?table={tableId}  - Landing page for a restaurant (optional table pre-fill)
 * /{restaurantSlug}/menu             - Menu view
 * /{restaurantSlug}/checkout         - Checkout view
 * /{restaurantSlug}/payment          - Payment view
 * /{restaurantSlug}/payment/complete - Payment complete view
 * 
 * Legacy routes (redirect to root):
 * /menu, /checkout, etc. without restaurant slug
 */

const routes = [
  // Root redirect - show error or redirect to a default
  {
    path: '/',
    name: 'root',
    component: () => import('../views/RestaurantNotFoundView.vue')
  },
  
  // Restaurant-specific routes
  {
    path: '/:restaurantSlug',
    name: 'landing',
    component: LandingView,
    props: true
  },
  {
    path: '/:restaurantSlug/menu',
    name: 'menu',
    component: MenuView,
    props: true
  },
  {
    path: '/:restaurantSlug/checkout',
    name: 'checkout',
    component: CheckoutView,
    props: true
  },
  {
    path: '/:restaurantSlug/payment',
    name: 'payment',
    component: PaymentView,
    props: true
  },
  {
    path: '/:restaurantSlug/payment/complete',
    name: 'payment-complete',
    component: PaymentCompleteView,
    props: true
  },

  // Legacy route redirects (for backwards compatibility during transition)
  {
    path: '/menu',
    redirect: '/'
  },
  {
    path: '/checkout',
    redirect: '/'
  },
  {
    path: '/payment',
    redirect: '/'
  },
  {
    path: '/payment/complete',
    redirect: '/'
  },

  // Catch-all 404
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/RestaurantNotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
